import { arrayToMap } from 'lib/array/arrayUtils'
import { TripDocumentsResult } from 'tripPlanner/hooks/api/documents'
import { FullTrip } from 'tripPlanner/types/common'
import { TripDocumentWithItemInfo } from 'tripPlanner/types/documents'
import { TripItem } from 'tripPlanner/types/tripItem'

export function flattenDocuments(
  trip: FullTrip,
  documents: TripDocumentsResult,
): TripDocumentWithItemInfo[] {
  const indexedItems = arrayToMap(trip.items, (item) => item.id)
  const attachedFiles = Object.entries(documents.attachedFiles).flatMap(
    ([itemId, files]) => {
      const item = indexedItems.get(itemId)
      if (item) {
        return files.map((file) => ({
          ...file,
          item: { id: item.id, name: getAttachedItemDisplayName(item) },
        }))
      }
      return files
    },
  )
  return [...attachedFiles, ...documents.unAttachedFiles]
}

export function getAttachedItemDisplayName(item: TripItem): string {
  if (item.type === 'FLIGHT') {
    return `${item.originAirportCode} - ${item.destinationAirportCode} flight`
  }
  if ('name' in item && item.name) {
    return item.name
  }
  if ('place' in item && item.place.name) {
    return item.place.name
  }
  return item.sortableName
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
